<template>
    <tab-layout :buttons="more.buttons">
        <template #title>
            {{ $l10n.__('Conditions Générales') }}
        </template>

        <template #content>
            <div v-if="loading" class="prelative mt-3">
                <preloader :display="loading" />
            </div>
            <div v-if="!loading" class="flex-column">
                <el-table :data="terms" style="overflow-y: auto; width: 100%">
                    <el-table-column
                        :label="$t.__('common.labels.type')"
                        width="100"
                        sortable
                        :sortMethod="sortAlphabetically"
                        :filters="termsDataFilters"
                        :filterMethod="filterIsTermsType"
                    >
                        <template #default="scope">
                            {{ termsData[scope.row.type].short }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t.__('common.labels.contact')"
                        sortable
                        :sortMethod="sortAlphabetically"
                    >
                        <template #default="scope">
                            <span v-if="scope.row.type == 'saas_cgu'">
                                {{ scope.row.acceptor.name }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t.__('overview.tabs.TabSamTermsList.current_version')"
                        :filters="[
                            { text: 'Oui', value: true },
                            { text: 'Non', value: false },
                        ]"
                        :filterMethod="filterIsLastVersion"
                        width="180"
                        :align="center"
                    >
                        <template #default="scope">
                            {{
                                $filters.capitalize(
                                    scope.row.isLastTermsVersion
                                        ? $l10n.__('oui')
                                        : $l10n.__('non'),
                                )
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="acceptor"
                        :label="$t.__('overview.tabs.TabSamTermsList.accepted')"
                        width="500"
                        :formatter="formatterAcceptance"
                    >
                    </el-table-column>
                    <el-table-column label="Url" width="150">
                        <template #default="scope">
                            <a :href="scope.row.link" target="_blank">{{ scope.row.version }}</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>
    </tab-layout>
</template>

<script>
import OverviewTabMixin from './OverviewTabMixin';
import { buildUrl } from '../../../helpers';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

export default {
    components: {
        Preloader,
        TabLayout,
    },
    mixins: [OverviewTabMixin],
    props: {
        more: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            customer: {},
            accounts: [],
            loading: true,
        };
    },
    computed: {
        buttons() {
            return [];
        },
        parameters() {
            return [
                {
                    key: 'corpid',
                    value: this.corporation,
                },
            ];
        },
        route() {
            return buildUrl(this.more.url, this.parameters);
        },
        corporation() {
            return this.$store.getters.dataFetch.sellsyadmin.id;
        },
        terms() {
            const terms = [];
            // Customer
            this.customer.forEach((term) => {
                terms.push(this.buildTermsObject(term));
            });
            // Accounts
            this.accounts.forEach((account) => {
                account.map((term) => {
                    terms.push(this.buildTermsObject(term));
                });
            });
            return terms;
        },
        termsData() {
            return {
                saas_cgu: {
                    label: this.$l10n.__("Conditions Générales d'Utilisation"),
                    short: 'CGU',
                },
                saas: {
                    label: this.$l10n.__("Conditions Générales de Vente et d'Utilisation"),
                    short: 'CGUV',
                },
                affil: {
                    label: this.$l10n.__('Conditions Générales de Parrainage'),
                    short: 'CGP',
                },
            };
        },
        termsDataFilters() {
            const filters = [];
            Object.keys(this.termsData).forEach((key) => {
                filters.push({
                    text: this.termsData[key].label,
                    value: key,
                });
            });
            return filters;
        },
    },
    created() {
        this.fetch();
    },
    methods: {
        addTermsInList(list, terms) {
            list.push(terms);
        },
        buildTermsObject(term) {
            return {
                type: term.type,
                version: term.version,
                date: term.created,
                acceptor:
                    null == term.acceptor
                        ? {}
                        : {
                              name: term.acceptor.name,
                              email: term.acceptor.email,
                          },
                status: term.status,
                link: term.url,
                isLastTermsVersion: term.isLastTermsVersion,
            };
        },
        fetch() {
            this.loading = true;
            this.$ajax.get(this.route, {}, (response) => {
                this.customer = response.customer;
                this.accounts = response.accounts;
                this.loading = false;
            });
        },
        formatterAcceptance(row) {
            if (row.status !== 'accepted') {
                return '-';
            }
            return this.$l10n.__('Le %(date)s par %(name)s (%(email)s)', {
                date: this.$filters.dateFormatter(
                    moment(row.date).unix(),
                    'NORMAL_DATE_TIME_WITH_DAY',
                    false,
                ),
                name: row.acceptor.name || this.$l10n.__('N/C'),
                email: row.acceptor.email || this.$l10n.__('N/C'),
            });
        },
        sortAlphabetically(currentStr, nextStr) {
            return currentStr == [currentStr, nextStr].sort()[0];
        },
        filterIsLastVersion(value, row) {
            return row.isLastTermsVersion === value;
        },
        filterIsTermsType(value, row) {
            return row.type === value;
        },
        buildUrl,
    },
};
</script>

<style scoped></style>
